import React, { useEffect } from 'react'
import { TextFieldSeeker } from "@ui-seeker/core"
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { userErrorRegistry, userPayload } from "Pages/Admin/Users/@signals"

import { object, string } from "yup"
import { useValidatorSeeker } from "@app"

export default function UserEmailField() {

	const { email, setEmailInfo } = useAdminUsersInfo(userPayload.peek()?.user?.email, "email", "user")

	const { errors, isValid } = useValidatorSeeker(
		{ email: email },
		object({
			email: string().required('Must provide an email').email('Email must have propper format')
		})
	)

	useEffect(() => {
		userErrorRegistry.value = { ...userErrorRegistry.peek(), email: isValid }
	}, [isValid])

	return <TextFieldSeeker
		value={email}
		label="Email"
		placeholder="Email"
		onChange={e => setEmailInfo(e.target.value)}
		error={errors?.email}
	/>
}